import { Component, ElementRef, inject, Input, output, AfterViewInit, OnDestroy } from '@angular/core';
import { NickyButtonComponent } from '../form/nicky-button/nicky-button.component';
import { CommonModule } from '@angular/common';
import { UserProfilePictureComponent } from '../user-profile-picture/user-profile-picture.component';
import { fromEvent, Subscription } from 'rxjs';
import { NickSearchResult } from '@app/services/search.service';
import { openLinkInANewTab } from '@app/utils/open-in-a-new-tab.utils';
import { User } from '../models/user.mode';
import { ProfileDto } from '@app/dtos/user-profile.dto';

@Component({
  selector: 'app-payer-info-tooltip',
  imports: [NickyButtonComponent, CommonModule, UserProfilePictureComponent],
  templateUrl: './payer-info-tooltip.component.html',
})
export class PayerInfoTooltipComponent implements AfterViewInit, OnDestroy {
  private documentClickSub!: Subscription;
  private nativeElement = inject(ElementRef).nativeElement;

  @Input() payerEmail: string = '';
  @Input() payerName: string = '';
  @Input() absolute: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() targetUser: NickSearchResult | ProfileDto | User | undefined = undefined;

  editName = output<void>();
  unlockInput = output<void>();
  close = output<boolean>();

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.documentClickSub = fromEvent<MouseEvent>(document, 'click').subscribe((event) => {
        const clickedInside = this.nativeElement.contains(event.target);
        if (!clickedInside) {
          this.close.emit(true);
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.documentClickSub?.unsubscribe();
  }

  onEditName(): void {
    this.editName.emit();
  }

  onViewProfile(): void {
    if (this.targetUser?.shortId) {
      openLinkInANewTab(`${window.location.origin}/s/${this.targetUser?.shortId}`);
    }
  }

  onUnlockInput(): void {
    this.unlockInput.emit();
  }

  get iconClass(): string {
    return `${!this.targetUser ? 'ph ph-pencil' : 'ph ph-arrow-line-up-right'} text-lg`;
  }
}
